import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

async function segnaClick(id) {
  try { await supabase.rpc('sponsor_incrementa_click', { sponsor_id: id }) } catch {}
}

export default function PaginaSponsor({ onChiudi }) {
  const [listaSponsor, setListaSponsor] = useState([])
  const [caricamento, setCaricamento] = useState(true)

  useEffect(() => {
    const oggi = new Date().toISOString().split('T')[0]
    supabase.from('sponsor').select('*')
      .eq('attivo', true).lte('data_inizio', oggi).gte('data_fine', oggi)
      .order('ordine', { ascending: true })
      .then(({ data }) => { setListaSponsor(data || []); setCaricamento(false) })
  }, [])

  function apriSponsor(s) {
    if (!s.link) return
    segnaClick(s.id)
    window.open(s.link, '_blank', 'noopener,noreferrer')
  }

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }} className="fade-in">
      <div className="topbar">
        <button className="back-btn" onClick={onChiudi} aria-label="Indietro">&larr;</button>
        <div style={{ fontFamily: 'Syne', fontWeight: 700 }}>I nostri sponsor</div>
        <div style={{ width: 24 }} />
      </div>

      <div className="scroll-area">
        {caricamento ? (
          <div style={{ textAlign: 'center', color: 'var(--muted)', padding: 40 }}>Caricamento...</div>
        ) : listaSponsor.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🏷️</div>
            <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 16, marginBottom: 8 }}>Nessuno sponsor al momento</div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {listaSponsor.map(s => (
              <div key={s.id} className="card" onClick={() => apriSponsor(s)} style={{ cursor: s.link ? 'pointer' : 'default' }}>
                <div className="card-body" style={{ display: 'flex', gap: 14, alignItems: 'center' }}>
                  <img src={s.immagine_url} alt={s.nome} style={{ width: 64, height: 64, borderRadius: 12, objectFit: 'cover', border: '1px solid var(--border)' }} />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 15 }}>{s.nome}</div>
                    {s.link && <div style={{ fontSize: 12, color: 'var(--accent2)', marginTop: 4 }}>Scopri di più →</div>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        <div style={{ textAlign: 'center', fontSize: 11, color: 'var(--muted)', padding: '20px 20px 4px' }}>
          Grazie a chi sostiene FitProgress 💚
        </div>
      </div>
    </div>
  )
}
